import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import DiagnosticPage from './DiagnosticPage';
import reportWebVitals from './reportWebVitals';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';

// Simple routing based on URL path
const isDiagnostic = window.location.pathname === '/diagnostic' || window.location.pathname === '/diagnostic/';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isDiagnostic ? <DiagnosticPage /> : <App />}
    <Analytics />
    <SpeedInsights />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
